import { EditOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next';
import { useState } from 'react'
import { NameEdit } from '../NameEdit';

export const NameGroupMassive = (props: {locationsIds: string[] }) => {
    
    const [edit, setEdit] = useState(false);
    const { t } = useTranslation();

return (
    <div>
       	<span onClick={() => setEdit(true)} style={{ display:"block",width:"100%",textDecoration: "none", fontSize: "16px", color: "#3C4043", cursor:"pointer" }}>{t('dictionary.name')} 
            <EditOutlined />
        </span>
        <NameEdit setEdit={setEdit} edit={edit} isMassive={true} setCurrentName={()=>{}} locationsIds={props.locationsIds} />
    </div>
)
}